import { useEffect, useMemo } from 'react';
import { readUniversalLinkParams } from '../searchParams/searchParams';
import { usePWELink } from './usePWELink';

export function useAutoOpenPWE(cannedConnection?: boolean): void {
  const pweLink = usePWELink(cannedConnection);

  const { savedSearchId, workAreaId, app } = readUniversalLinkParams();

  const autoOpenPWE = useMemo((): boolean => {
    if (app != 'pwe') {
      return false;
    }

    if (savedSearchId) {
      return false;
    }

    if (!workAreaId) {
      return false;
    }

    return true;
  }, [app, savedSearchId, workAreaId]);

  useEffect(() => {
    if (!autoOpenPWE || !pweLink) {
      return;
    }

    window.location.href = pweLink;
  }, [autoOpenPWE, pweLink]);
}
